export default __webpack_public_path__ + "static/media/product-tour1.a3ae7bd9.svg";